export default __webpack_public_path__ + "static/media/c_k.5a6289a2.svg";